import Vue from "vue";
import { VueTreeList, Tree, TreeNode } from 'vue-tree-list-v2';

function checkAllChildren(model) {
	let results = [];
	if (model.children != null && model.children.length > 0) {
		model.children.forEach(value => {
			results.push(value.productCode);
			if (value.children != null && value.children.length > 0) {
				results.push(...checkAllChildren(value));
			}
		});
	}

	return results;
}

function arrayRemove(productCodes, value) {
	return productCodes.filter(function (codes) {
		return codes != value;
	});

}

function uncheckAllChildren(model, productCodes) {
	let results = productCodes;

	if (model.children != null && model.children.length > 0) {
		model.children.forEach(value => {
			results = arrayRemove(results, value.productCode);

			if (value.children != null && value.children.length > 0) {
				results = uncheckAllChildren(value, results);
			}
		});
	}

	return results;
}

Vue.component("classification-hierarchy", {
    props: ["useModal", "classificationSystem", "selectedCodes"],
    data() {
        return {
            showModal: false,
            hierarchies: null,
            classificationCode: this.classificationSystem,
            productCodes: this.selectedCodes,
			loading: false
        };
    },
    methods: {
        initialize() {
            const self = this;

			self.showModal = true;
			self.loading = true;

			self.$services.classificationHierarchies.getHierarchies({
                classificationSystemCode: self.classificationCode,
                language: window.currentLanguage
            }).then((data) => {
				self.hierarchies = new Tree(data);
				self.$emit('update:loading', self.load);
				self.loading = false;
            });
        },
        discard() {
            this.showModal = false;
        },
        done() {
            const self = this;

            self.$emit('update:selectedCodes', self.productCodes);
            self.showModal = false;
		},
		selectProductCode(model, event) {
			const self = this;

			if (model != null) {
				self.$nextTick(() => {
					if (event.target.checked) {
						self.productCodes.push(...checkAllChildren(model));
					}
					else {
						self.productCodes = uncheckAllChildren(model, self.productCodes);
					}
				})
			}
		}
	},
	mounted() {
		this.initialize();
	},
    watch: {
		productCodes: function (val) {
            const self = this;
			if (val != null) {
				if (self.showModal) {
					self.$emit('update:selectedCodes', val);
				}
			}
        }
    },
    template: `
		<div>
			<b-modal v-if="useModal" v-model="showModal" id="classificationSelectorModal" :canCancel="false" full-screen ref="classificationSelectorModal">
				<div class="modal-card" style="overflow-y: auto;">
					<header class="modal-card-head">
						<p class="modal-card-title">{{classificationCode}}</p>
					</header>
					<section class="modal-card-body">
						<template v-if="loading"><loading></loading></template>
						<template v-else>				                    
							<div v-if="hierarchies != null">
								<vue-tree-list
									:model="hierarchies"									
									v-bind:default-expanded="true">
									<template v-slot:leafNameDisplay="props">
										<div class="entity-row" :id="'hierarchy_' + props.model.id">
											<div class="entity-row-reference-number pr-2">{{ props.model.productCode }}</div>
											<div class="entity-row-display-name">{{ props.model.name}}</div>
										</div>				
									</template>
									<template v-slot:treeNodeIcon="props">
										<span class="icon">
											<input type="checkbox" :id="props.model.id" :name="props.model.pid" :value="props.model.productCode" v-model="productCodes" @change="selectProductCode(props.model, $event)" />
										</span>
									</template>
								</vue-tree-list>
							</div>
						</template>
					</section>
					<footer class="modal-card-foot buttons">
						<button type="button" class="button is-primary" v-if="productCodes.length > 0" @click="done">Done with selection</button>
						<button type="button" class="button is-danger" @click="discard">Discard</button>
					</footer>
				</div>
			</b-modal>
			<div v-else>
				<template v-if="loading"><loading></loading></template>
				<template v-else>						
					<div v-if="hierarchies != null">
						<vue-tree-list
							:model="hierarchies"									
							v-bind:default-expanded="false">
							<template v-slot:leafNameDisplay="props">
								<div class="entity-row" :id="'hierarchy_' + props.model.id">
									<div class="entity-row-reference-number pr-2">{{ props.model.productCode }}</div>
									<div class="entity-row-display-name">{{ props.model.name}}</div>
								</div>				
							</template>
							<template v-slot:treeNodeIcon="props">
								<span class="icon">
									<input type="checkbox" :id="props.model.id" :name="props.model.pid" :value="props.model.productCode" v-model="productCodes" @change="selectProductCode(props.model, $event)" />
								</span>
							</template>
						</vue-tree-list>
					</div>
				</template>
			</div>
		</div>
	`
});